<template>
  <div>
    <Filtro :vistoria="false" @filtro="makeFiltro"></Filtro>
    <div class="vx-row">
      <div class="vx-col w-full md:w-1/4 mb-base">
        <vs-card>
          <vs-list>
            <vs-list-header
              icon-pack="feather"
              icon="icon-bar-chart-2"
              title="Cancelamento"
            ></vs-list-header>
            <vs-list-item
              icon-pack="feather"
              icon="icon-database"
              title="Cancelamento por Status"
              v-if="$can('Cancelamento por Status', subjectPermission)"
            >
              <vs-button
                @click="selecionaGrafico('Status', 1)"
                color="primary"
                type="border"
                icon-pack="feather"
                icon="icon-search"
              ></vs-button>
            </vs-list-item>
            <vs-list-item
              icon-pack="feather"
              icon="icon-briefcase"
              title="Retidos x Não Retidos"
              v-if="$can('Retidos x Não Retidos', subjectPermission)"
              ><vs-button
                @click="selecionaGrafico('Retidos x Não Retidos', 1)"
                color="primary"
                type="border"
                icon-pack="feather"
                icon="icon-search"
              ></vs-button
            ></vs-list-item>
            <vs-list-item
              icon-pack="feather"
              icon="icon-archive"
              title="Cancelamento por Motivo"
              v-if="$can('Cancelamento por Motivo', subjectPermission)"
              ><vs-button
                @click="selecionaGrafico('Cancelamento por Motivo', 1)"
                color="primary"
                type="border"
                icon-pack="feather"
                icon="icon-search"
              ></vs-button
            ></vs-list-item>
          </vs-list>
        </vs-card>
      </div>
      <div class="vx-col w-full md:w-3/4 mb-base">
        <vs-card>
          <div v-if="tipoGrafico">
            <h4>
              {{ tipoGrafico }} {{ formataData2(this.objSend.dataInicial) }} -
              {{ formataData2(this.objSend.dataFinal) }}
            </h4>
            <vue-apex-charts
              v-if="carregado == true && estiloGrafico == 1"
              type="bar"
              height="350"
              :options="analyticsData.cancelamentosBar.chartOptions"
              :series="analyticsData.cancelamentosBar.series"
            ></vue-apex-charts>
          </div>
          <div v-else class="text-center">
            <img
              src="../../../assets/images/pages/graphic-3.png"
              alt="graphic-404"
              class="mx-auto mb-4 max-w-full"
            />
            <h1 class="sm:mx-0 mx-4 mb-12 text-5xl d-theme-heading-color">
              Cancelamentos
            </h1>
            <p class="sm:mx-0 mx-4 mb-4 sm:mb-16">
              Veja os indicadores de Retenção e Cancelamento
            </p>
            <p class="sm:mx-0 mx-4 mb-4 sm:mb-16">
              Selecione o periodo, e os demais filtros, depois selecione o tipo
              de relatório no box ao lado.
            </p>
          </div>
        </vs-card>
      </div>
    </div>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import StatisticsCardLine from "@/components/statistics-cards/StatisticsCardLine.vue";
import Filtro from "./../../filtros/FiltroGraficoCrescimento";
import analyticsData from "./../../../ui-elements/card/analyticsData.js";
import service from "./../../../services";
import moment from "moment";
export default {
  data() {
    return {
      realizaFiltro: false,
      filtro: null,
      tipoGrafico: null,
      objSend: {},
      analyticsData: analyticsData,
      estiloGrafico: null,
      carregado: false,
      dadosResult: {
        tempoMedio: [0, 0, 0],
        taxaConversao: {
          taxa: [0],
          total: 0,
          convertidas: 0,
        },
      },
      subjectPermission: "Cancelamentos",
    };
  },
  methods: {
    selecionaGrafico(tipoGrafico, estiloGrafico) {
      this.tipoGrafico = tipoGrafico;
      this.estiloGrafico = estiloGrafico;
      this.filtraGeral();
    },
    preparaFiltro() {
      this.objSend = {};

      if (this.filtro) {
        this.objSend = { ...this.filtro };
        this.objSend.dataInicial = moment(this.filtro.dataInicial).format(
          "YYYY-MM-DD"
        );
        this.objSend.dataFinal = moment(this.filtro.dataFinal).format(
          "YYYY-MM-DD"
        );
      } else {
        var date = new Date();
        var primeiroDia = new Date(date.getFullYear(), date.getMonth(), 1);
        var ultimoDia = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        console.log(primeiroDia, ultimoDia);
        this.objSend.dataInicial = moment(primeiroDia).format("YYYY-MM-DD");
        this.objSend.dataFinal = moment(ultimoDia).format("YYYY-MM-DD");
      }
      this.objSend.tipo = this.tipoGrafico;
    },
    formataData2(data) {
      return moment(data).format("DD/MM/YYYY");
    },
    makeFiltro(filtro) {
      this.realizaFiltro = true;
      this.filtro = filtro;
      this.filtraGeral();
    },
    filtraGeral() {
      this.preparaFiltro();
      this.buscaDados();
    },
    finalizaFiltro() {
      this.realizaFiltro = false;
    },
    buscaDados() {
      this.buscaDadosCancelamentoFiltro();
    },
    buscaDadosCancelamentoFiltro() {
      this.carregado = false;
      this.$vs.loading();
      var objSend = { ...this.objSend };
      service
        .post("Relatorios", "relatorioCancelamentos", objSend)
        .then((res) => {
          console.log(res.data);
          if (this.estiloGrafico == 1) {
            var arrList = [];
            var arrQtd = [];
            res.data.forEach((element) => {
              arrList.push(element.lista);
              arrQtd.push(element.qtd);
            });
            analyticsData.cancelamentosBar.chartOptions.xaxis.categories = arrList;
            analyticsData.cancelamentosBar.series[0].data = arrQtd;
          }

          this.carregado = true;
          this.$vs.loading.close();
        });
    },
  },
  components: {
    Filtro,
    VueApexCharts,
    StatisticsCardLine,
  },
};
</script>
